import * as React from 'react';
import { AutoScrollbars, Filters, FilterComponentType } from 'components';
import { IFilter, actions as containersActions } from 'services/containers/containers-service';
import { WithTranslation, withTranslation } from 'react-i18next';
import { romanToArabSortAsc } from 'utils/sort/roman-number-converter';
import { deepClone } from 'utils';
import { InfrastructureFilter } from './infrastructure-filter';

export interface ITabGeneralProps extends WithTranslation {
    filters: IFilter[];
    AREA_FILTER_ID?: number;
    SPB_DISTANCE_FILTER_ID?: number;
    ALLOWED_USAGE_TYPE_FILTER_ID?: number;
    DANGER_CLASS_FILTER_ID?: number;
    POWERS_FILTER_ID?: number;
    GAS_FILTER_ID?: number;
    WATER_SUPPLY?: number;
    SEWERAGE?: number;
}
export interface ITabGeneralState {}

class TabGeneralComponent extends React.Component<ITabGeneralProps, ITabGeneralState> {
    constructor(props: ITabGeneralProps) {
        super(props);

        this.onFilterChange = this.onFilterChange.bind(this);
    }

    onFilterChange(filter_id: number, filter_value: any, debounced = false) {
        if (!debounced) {
            containersActions.setFilter({
                code: 'plots',
                id: filter_id,
                value: filter_value
            });
        } else {
            containersActions.setFilterDebounced({
                code: 'plots',
                id: filter_id,
                value: filter_value
            });
        }
    }

    private renderFilterComponentById<T extends React.FC>(
        filter_id: number,
        rest_props: Partial<React.ComponentProps<T>> = {}
    ) {
        let filter = this.props.filters.find(f => f.id === filter_id);
        if (!filter) return null;
        if (filter_id === 11111) {
            const baseFilter = this.props.filters.find(f => f.id === 57);
            filter = deepClone(baseFilter);
            filter.name = 'Возможность подключения к газоснабжению';
            filter.value = [ 1, 6, false ];
        }
        let FilterComponent = filter.id === 22 ? Filters['log_range'] : Filters[filter.type];

        if ([ 24, 26 ].includes(filter.id)) {
            filter.settingsFilter.select = true;
        }

        return (
            <FilterComponent
                filter={filter}
                {...rest_props}
            />
        );
    }

    render() {
        const {
            /** Площадь */
            AREA_FILTER_ID = 22,
            /** Расстояние до КАД СПБ */
            SPB_DISTANCE_FILTER_ID = 32,
            /** Вид разрешенного использования */
            ALLOWED_USAGE_TYPE_FILTER_ID = 26,
            /** Класс опасности */
            DANGER_CLASS_FILTER_ID = 24,
            /** Питание */
            POWERS_FILTER_ID = 57,
            /** Газоснабжение */
            GAS_FILTER_ID = 61,
            /** Водоснабжение */
            WATER_SUPPLY = 62,
            /** Водоотведение */
            SEWERAGE = 63,
            t
        } = this.props;

        return (
            <div className='general-tab-wrapper'>
                <AutoScrollbars>
                    <div className="general-filters-wrapper">

                        <div className="filters-column left-filters">
                            {this.renderFilterComponentById<typeof Filters[ 'list_text' ]>(DANGER_CLASS_FILTER_ID, {
                                onFilterChange: this.onFilterChange,
                                className: 'no-shrink',
                                sortListItems: romanToArabSortAsc
                            })}

                            {this.renderFilterComponentById<typeof Filters['range']>(AREA_FILTER_ID, {
                                onFilterChange: this.onFilterChange
                            })}
                            {this.renderFilterComponentById<typeof Filters['gas']>(GAS_FILTER_ID, {
                                onFilterChange: this.onFilterChange,
                                minValue: 0,
                                steps: [ 2, 5, 10 ]
                            })}
                            {this.renderFilterComponentById<typeof Filters['powers']>(POWERS_FILTER_ID, {
                                onFilterChange: this.onFilterChange,
                                minValue: 0,
                                steps: [ 1, 3, 6 ]
                            })}
                        </div>
                        <div className="filters-column right-filters">
                            {this.renderFilterComponentById<typeof Filters['list_text']>(
                                ALLOWED_USAGE_TYPE_FILTER_ID, {
                                    onFilterChange: this.onFilterChange
                                }
                            )}
                            {this.renderFilterComponentById<typeof Filters['range']>(SPB_DISTANCE_FILTER_ID, {
                                onFilterChange: this.onFilterChange
                            })}
                            {this.renderFilterComponentById<typeof Filters['water_supply']>(SEWERAGE, {
                                onFilterChange: this.onFilterChange
                            })}
                            {this.renderFilterComponentById<typeof Filters['sewerage']>(WATER_SUPPLY, {
                                onFilterChange: this.onFilterChange
                            })}
                            <div className="inline-filters" style={{ marginTop: 2 }}>
                                <InfrastructureFilter
                                    title={t('Наличие инфраструктуры')}
                                    filters={this.props.filters}
                                    className='no-shrink'
                                    onFilterChage={(new_filter) => {
                                        containersActions.setFilter({
                                            code: 'plots',
                                            id: new_filter.id,
                                            value: new_filter.value
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </AutoScrollbars>
            </div>
        );
    }
}

export const TabGeneral = withTranslation()(TabGeneralComponent);
